export const WhoWeServesData = [
 {
  imageName: 'static/svg/cml/individuals.svg',
  description: 'Individuals',
 },
 {
  imageName: 'static/svg/cml/resallers.svg',
  description: 'Resellers ',
 },
 {
  imageName: 'static/svg/cml/businesses.svg',
  description: 'Businesses of all scales',
 },
];
